import AZ from './aZ';
import Acca from './acca';
import Account from './account';
import Add from './add';
import AlpineSkiing from './alpineSkiing';
import AmericanFootball from './americanFootball';
import Archery from './archery';
import Athletics from './athletics';
import AustralianRules from './australianRules';
import Badminton from './badminton';
import Baseball from './baseball';
import Basketball from './basketball';
import BetBuilder from './betBuilder';
import Betslip from './betslip';
import Biathlon from './biathlon';
import Bobsleigh from './bobsleigh';
import Bowls from './bowls';
import Boxing from './boxing';
import Break from './break';
import Canoeing from './canoeing';
import Cash from './cash';
import ChevronMediumDown from './chevronMediumDown';
import ChevronMediumLeft from './chevronMediumLeft';
import ChevronMediumRight from './chevronMediumRight';
import ChevronMediumUp from './chevronMediumUp';
import ChevronSmallDown from './chevronSmallDown';
import ChevronSmallLeft from './chevronSmallLeft';
import ChevronSmallRight from './chevronSmallRight';
import ChevronSmallUp from './chevronSmallUp';
import Clock from './clock';
import CloseMedium from './closeMedium';
import CloseSmall from './closeSmall';
import Cricket from './cricket';
import CrossCountrySki from './crossCountrySki';
import Curling from './curling';
import Cycling from './cycling';
import Darts from './darts';
import Delete from './delete';
import Diving from './diving';
import Equestrian from './equestrian';
import Error from './error';
import Esports from './esports';
import F1 from './f1';
import Facebook from './facebook';
import Fencing from './fencing';
import FigureSkating from './figureSkating';
import Finished from './finished';
import Finishingpost from './finishingpost';
import Flame from './flame';
import Football from './football';
import FreeBet from './freeBet';
import FreeBetSb from './freeBetSb';
import FreestyleSkiing from './freestyleSkiing';
import GaaFootball from './gaaFootball';
import GaaHurling from './gaaHurling';
import Gift from './gift';
import Golf from './golf';
import Greyhounds from './greyhounds';
import Gymnastics from './gymnastics';
import Hamburger from './hamburger';
import Handball from './handball';
import Hockey from './hockey';
import Home from './home';
import Horse from './horse';
import IceHockey from './iceHockey';
import InPlay from './inPlay';
import Info from './info';
import Instagram from './instagram';
import Judo from './judo';
import KeyboardBackspace from './keyboardBackspace';
import Kickboxing from './kickboxing';
import LineBeachVolleyball from './lineBeachVolleyball';
import Luge from './luge';
import Marker from './marker';
import MixedMartialArts from './mixedMartialArts';
import MotorRacing from './motorRacing';
import Multiples from './multiples';
import MyBets from './myBets';
import MyBetsLose from './myBetsLose';
import MyBetsPlaced from './myBetsPlaced';
import MyBetsVoid from './myBetsVoid';
import MyBetsWin from './myBetsWin';
import Netball from './netball';
import Novelty from './novelty';
import Oddsboost from './oddsboost';
import OddsboostFull from './oddsboostFull';
import OutlineInfo from './outlineInfo';
import Padlock from './padlock';
import Pentathlon from './pentathlon';
import PokerFill from './pokerFill';
import PokerLine from './pokerLine';
import Pool from './pool';
import PriceBoost from './priceBoost';
import Promo from './promo';
import Rab from './rab';
import RabFull from './rabFull';
import Refresh from './refresh';
import Rowing from './rowing';
import RugbyLeague from './rugbyLeague';
import RugbyUnion from './rugbyUnion';
import Sailing from './sailing';
import Search from './search';
import Settings from './settings';
import Shooting from './shooting';
import Skeleton from './skeleton';
import SkiJumping from './skiJumping';
import Snooker from './snooker';
import Snowboarding from './snowboarding';
import Specials from './specials';
import SportsMenu from './sportsMenu';
import Star from './star';
import StarEmpty from './starEmpty';
import StarSub from './starSub';
import StarRewards from './starRewards';
import Surfing from './surfing';
import Swimming from './swimming';
import TableTennis from './tableTennis';
import Taekwondo from './taekwondo';
import Tennis from './tennis';
import TfVerdict from './tfVerdict';
import TickMedium from './tickMedium';
import TickSmall from './tickSmall';
import Time from './time';
import Timeform from './timeform';
import Trash from './trash';
import Triathlon from './triathlon';
import Trophy from './trophy';
import Twitch from './twitch';
import Twitter from './twitter';
import Virtuals from './virtuals';
import Volleyball from './volleyball';
import WaterPolo from './waterPolo';
import Weightlifting from './weightlifting';
import WinterOlympics from './winterOlympics';
import WinterSports from './winterSports';
import Wrestling from './wrestling';
import Youtube from './youtube';

export default {
  'a-z': AZ,
  acca: Acca,
  account: Account,
  add: Add,
  'alpine-skiing': AlpineSkiing,
  'american-football': AmericanFootball,
  archery: Archery,
  athletics: Athletics,
  'australian-rules': AustralianRules,
  badminton: Badminton,
  baseball: Baseball,
  basketball: Basketball,
  'bet-builder': BetBuilder,
  betslip: Betslip,
  biathlon: Biathlon,
  bobsleigh: Bobsleigh,
  bowls: Bowls,
  boxing: Boxing,
  break: Break,
  canoeing: Canoeing,
  cash: Cash,
  'chevron-medium-down': ChevronMediumDown,
  'chevron-medium-left': ChevronMediumLeft,
  'chevron-medium-right': ChevronMediumRight,
  'chevron-medium-up': ChevronMediumUp,
  'chevron-small-down': ChevronSmallDown,
  'chevron-small-left': ChevronSmallLeft,
  'chevron-small-right': ChevronSmallRight,
  'chevron-small-up': ChevronSmallUp,
  clock: Clock,
  'close-medium': CloseMedium,
  'close-small': CloseSmall,
  cricket: Cricket,
  'cross-country-ski': CrossCountrySki,
  curling: Curling,
  cycling: Cycling,
  darts: Darts,
  delete: Delete,
  diving: Diving,
  equestrian: Equestrian,
  error: Error,
  esports: Esports,
  'f-1': F1,
  facebook: Facebook,
  fencing: Fencing,
  'figure-skating': FigureSkating,
  finished: Finished,
  finishingpost: Finishingpost,
  flame: Flame,
  football: Football,
  'free-bet': FreeBet,
  'free-bet-sb': FreeBetSb,
  'freestyle-skiing': FreestyleSkiing,
  'gaa-football': GaaFootball,
  'gaa-hurling': GaaHurling,
  gift: Gift,
  golf: Golf,
  greyhounds: Greyhounds,
  gymnastics: Gymnastics,
  hamburger: Hamburger,
  handball: Handball,
  hockey: Hockey,
  home: Home,
  horse: Horse,
  'ice-hockey': IceHockey,
  'in-play': InPlay,
  info: Info,
  instagram: Instagram,
  judo: Judo,
  'keyboard-backspace': KeyboardBackspace,
  kickboxing: Kickboxing,
  'line-beach-volleyball': LineBeachVolleyball,
  luge: Luge,
  marker: Marker,
  'mixed-martial-arts': MixedMartialArts,
  'motor-racing': MotorRacing,
  multiples: Multiples,
  'my-bets': MyBets,
  'my-bets-lose': MyBetsLose,
  'my-bets-placed': MyBetsPlaced,
  'my-bets-void': MyBetsVoid,
  'my-bets-win': MyBetsWin,
  netball: Netball,
  novelty: Novelty,
  oddsboost: Oddsboost,
  'oddsboost-full': OddsboostFull,
  'outline-info': OutlineInfo,
  padlock: Padlock,
  pentathlon: Pentathlon,
  'poker-fill': PokerFill,
  'poker-line': PokerLine,
  pool: Pool,
  'price-boost': PriceBoost,
  promo: Promo,
  rab: Rab,
  'rab-full': RabFull,
  refresh: Refresh,
  rowing: Rowing,
  'rugby-league': RugbyLeague,
  'rugby-union': RugbyUnion,
  sailing: Sailing,
  search: Search,
  settings: Settings,
  shooting: Shooting,
  skeleton: Skeleton,
  'ski-jumping': SkiJumping,
  snooker: Snooker,
  snowboarding: Snowboarding,
  specials: Specials,
  'sports-menu': SportsMenu,
  star: Star,
  'star-empty': StarEmpty,
  'star-sub': StarSub,
  'star-rewards': StarRewards,
  surfing: Surfing,
  swimming: Swimming,
  'table-tennis': TableTennis,
  taekwondo: Taekwondo,
  tennis: Tennis,
  'tf-verdict': TfVerdict,
  'tick-medium': TickMedium,
  'tick-small': TickSmall,
  time: Time,
  timeform: Timeform,
  trash: Trash,
  triathlon: Triathlon,
  trophy: Trophy,
  twitch: Twitch,
  twitter: Twitter,
  virtuals: Virtuals,
  volleyball: Volleyball,
  'water-polo': WaterPolo,
  weightlifting: Weightlifting,
  'winter-olympics': WinterOlympics,
  'winter-sports': WinterSports,
  wrestling: Wrestling,
  youtube: Youtube
};
